<template>
    <Widget :title="$t('components.MostCommonlyQuestion.QuestionLabel')" :bigHeader="true" :loading="loading" :info="$t('widgetsInfo.MostCommonlyQuestion')" :report-mode="reportMode">
        <div class="d-block text-center text-h4 blue--text">{{ chatsData }}</div>
    </Widget>
</template>

<script>
import Widget from '@/components/dashboard/Widget';

export default {
    name: 'MostCommonlyQuestion',
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        chatsData: {
            type: String,
            default: "-"
        },
        reportMode: {
            type: String,
            default: null
        }
    },
    components: { Widget }
}
</script>